import { createSlice } from "@reduxjs/toolkit";

const guardaregistroviajesState = {
  guardaregistroviajesdata: [],
};

const guardaregistroviajesSlice = createSlice({
  name: "guardaregistroviajes",
  initialState: guardaregistroviajesState,
  reducers: {
    GuardaRegistroViajesData: (state, actions) => actions.payload,
    CancelarGuardaRegistroViajesData: () => guardaregistroviajesState
  },
});

export const { GuardaRegistroViajesData, CancelarGuardaRegistroViajesData } = guardaregistroviajesSlice.actions;

export default guardaregistroviajesSlice.reducer;